import rutasBase from "./routes";
import rutasCMS from "./cms.routes";
import rutasInterconexion from "./interconexion.routes";
const apikey = process.env.REACT_APP_MAP_KEY;

export { rutasBase as rutas, apikey, rutasCMS, rutasInterconexion };
